const TTL_MS = 30 * 60 * 1000;

let expiredPassword: string | null = null;
let expiresAt = 0;

export function setExpiredPassword(password: string): void {
  expiredPassword = password;
  expiresAt = Date.now() + TTL_MS;
}

export function getExpiredPassword(): string | null {
  if (expiredPassword !== null && Date.now() >= expiresAt) {
    clearExpiredPassword();
  }

  return expiredPassword;
}

export function clearExpiredPassword(): void {
  expiredPassword = null;
  expiresAt = 0;
}
